export const FLOATING_MENU_OVERFLOW_PADDING = 20

export const FLOATING_MENU_CONTENT_PADDING = 8

export const FLOATING_MENU_MINIMUM_MAX_HEIGHT = 250
